import { render, staticRenderFns } from "./EmploymentType.vue?vue&type=template&id=601da4b3&"
import script from "./EmploymentType.vue?vue&type=script&lang=js&"
export * from "./EmploymentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports